import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import SubPageHeader from '../components/SubPageHeader';
import StoveFamilyList from '../components/StoveFamilyItems';

export default function PartsPage({ data }) {
  const families = data.families.nodes;
  return (
    <Layout>
      <SubPageHeader title="Parts" />
      <StoveFamilyList families={families} parentUrl="parts" />
    </Layout>
  );
}

export const query = graphql`
  query {
    families: allSanityStoveFamily {
      nodes {
        id
        name
        image {
          asset {
            fluid(maxWidth: 400) {
              ...GatsbySanityImageFluid
            }
          }
        }
        url {
          current
        }
      }
    }
  }
`;
